import styled from 'styled-components';

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 5.8rem;

  position: sticky;
  top: 0;

  @media (max-width: 768px) {
    padding: 0 2rem;
  }
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;
`;

export const SaveButton = styled.button`
  width: 31.7rem;
  height: 4.4rem;
  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5rem;

  font-size: 1.8rem;
  font-weight: bold;
`;

export const Container = styled.div`
  padding: 3.6rem 3.1rem;
`;

export const FieldSet = styled.fieldset`
  border: none;

  display: flex;
  flex-direction: column;

  margin-bottom: 3.7rem;
`;

export const InputLabel = styled.span`
  font-size: 1.5rem;
  font-weight: bold;

  padding: 0 1.8rem;
  color: #fff;
  margin-bottom: 0.5rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.8rem;

  max-width: 32rem;
`;

type RadioButtonProps = {
  isSelected?: boolean;
};

export const RadioButton = styled.button.attrs({
  type: 'button',
})<RadioButtonProps>`
  margin-bottom: 0.7rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.2rem;
    height: 2.2rem;
    background: #000;

    border: 1px solid #fff;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 1px solid #000;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#fff' : false)};
  }

  p {
    color: #fff;

    font-size: 1.5rem;
    padding: 0 0.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.8);
  }
`;
